import {Map} from 'immutable';

import * as Signin from '../../actions/auth/SigninAction';
import * as Signout from '../../actions/auth/SignoutAction';
import * as LoadAuth from '../../actions/auth/loadAuthAction';
import * as SessionExpired from '../../actions/auth/sessionExpiredAction';
import * as PhoneConfirm from '../../actions/PhoneConfirmation';
import * as FastJoin from '../../actions/auth/FastJoin';

//sport-betting
import * as AuthActions from 'actions/Auth';
import * as PasswordRecoveryActions from 'actions/PasswordRecovery';

import * as AuthError from 'constants/AuthError';

const initialState = Map({
    signInOngoing: false,
    isAuthenticating: null,
    isSignout: null,
    user: null,
    authError: null
});

export default function auth(state = initialState, action = {}) {
    switch (action.type) {
        case PhoneConfirm.SUCCESS_CONFIRM_PHONE:
            if (action.data.User) {
                let user = Map({
                    gamblerId: action.data.User.Id,
                    login: action.data.User.Login,
                    accountId: action.data.User.AccountId,
                    accountNum: action.data.User.AccountNumber,
                    gamblerAccountId: action.data.User.GamblerAccountId,
                    isVerified: action.data.IsVerified,
                    resourceId: action.data.User.AccountResourceId,
                    selfBlockingExpired: action.data.User.SelfBlockingEndDate,
                    selfBlockingUnlock: action.data.User.SelfBlockingUnlock,
                    name: action.data.User.FirstName,
                    lastName: action.data.User.LastName,
                    email: action.data.User.Email
                });

                state = state.set('user', user);
            }
            break;

        case SessionExpired.SESSION_EXPIRED:
            state = initialState;
            break;

        case Signin.SIGNIN:
        case LoadAuth.RESTORE:
            state = state.set('isAuthenticating', true);
            state = state.set('authError', null);
            break;

        case Signout.SIGNOUT:
            state = state.set('isSignout', true);
            break;

        case Signin.SUCCESS_SIGNIN:
        case LoadAuth.SUCCESS_RESTORE:
        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE: {
            state = state.set('isAuthenticating', false);
            // auth responded with error
            const error = action.data.Error;
            if (error !== undefined) {

                state = state.set('authError', error);

                if (error === AuthError.NOT_ACTIVATED) {
                    state = state.set('email', action.data.Email);
                }
            } else {
                let user = Map({
                    gamblerId: action.data.Id,
                    login: action.data.Login,
                    accountId: action.data.AccountId,
                    accountNum: action.data.AccountNumber,
                    gamblerAccountId: action.data.GamblerAccountId,
                    isVerified: action.data.IsVerified,
                    resourceId: action.data.AccountResourceId,
                    selfBlockingExpired: action.data.SelfBlockingEndDate,
                    selfBlockingUnlock: action.data.SelfBlockingUnlock,
                    name: action.data.FirstName,
                    lastName: action.data.LastName,
                    phone: action.data.Phone,
                    email: action.data.Email,
                    joinPromo: action.data.JoinPromo,
                    phoneConfirmed: action.data.IsPhoneConfirmed
                });

                if (action.data.CountryId) {
                    user = user.update('countryId', ()=> action.data.CountryId);
                }

                state = state.set('user', user);
                state = state.set('authError', null);
                state = state.set('signInOngoing', false);
            }
            break;
        }

        case Signout.SUCCESS_SIGNOUT:
            if (action.data.Result) {
                state = state.set('isAuthenticating', false);
                state = state.set('user', null);
                state = state.set('isSignout', false);
            }
            break;

        case AuthActions.BEGIN_SIGNIN:
            state = state.set('signInOngoing', true);
            break;

        case AuthActions.BEGIN_JOIN:
            state = state.set('signInOngoing', false);
            break;

        case AuthActions.CANCEL_SIGNIN:
        case PasswordRecoveryActions.BEGIN_PASSWORD_RECOVERY:
            state = state.set('signInOngoing', false);
            state = state.set('authError', null);
            break;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/shared/reducers/auth.js